module.exports = __webpack_public_path__ + "img/jd_icon6.e3f5ccc5.png";